export const config = window.addiesaas.config

export default {
  data: () => ({
    config
  }),
}

